import translation from "../../assets/locales/et/translation.json5";

export const GROUP__RED = 'red';
export const GROUP__YELLOW = 'yellow';
export const GROUP__GREEN = 'green';

export const GROUP__BLUE = 'blue';

export const GROUP__TRIANGLE_YELLOW = 'triangle_yellow';
export const GROUP__TRIANGLE_ORANGE = 'triangle_orange';

export const INSTALLATIONSSYSTEM_GEBERIT_DUOFIX = 'geberit_duofix';
export const INSTALLATIONSSYSTEM_GEBERIT_GIS = 'geberit_gis';
export const INSTALLATIONSSYSTEM_GEBERIT_KOMBIFIX = 'geberit_kombifix';

export const WANDAUFBAU__VORWANDINSTALLATION_VOR_MASSIVER_TRENNWAND = 'vorwandinstallation_vor_massiver_trennwand';
export const WANDAUFBAU__VORWANDINSTALLATION_VOR_TROCKENBAUWAND = 'vorwandinstallation_vor_trockenbauwand';
export const WANDAUFBAU__RAUMABSCHLIESSENDE_TROCKENBAUWAND = 'raumabschliessende_trockenbauwand';
export const WANDAUFBAU__VORWANDINSTALLATION_GEBERIT_DUOFIX = 'vorwandinstallation_duofix';
export const WANDAUFBAU__MONTAGEELEMENT_RAUMABSCHLIESSENDE_TROCKENBAUWAND = 'montageelement_raumabschliessende_trockenbauwand';
export const WANDAUFBAU__MONTAGEELEMENT_GEMAUERTER_VORWAND = 'montageelement_gemauerter_vorwand';

export const STEINSORTE_BASISWAND_GEBERIT = 'basiswand_geberit';
export const STEINSORTE_BIMS_VOLLSTEINE = 'bims_vollsteine';
export const STEINSORTE_BIMS_HOHLBLOCKSTEINE = 'bims_holblocksteine';
export const STEINSORTE_HOCHLOCHZIEGEL_KLEIN = 'hochlochziegel_klein';
export const STEINSORTE_LEICHTZIEGEL_GROSS = 'leichtziegel_gross';
export const STEINSORTE_PORENZIEGEL = 'porenziegel';
export const STEINSORTE_GASBETONSTEINE = 'gasbetonsteine';
export const STEINSORTE_KALKSANDSTEINE_VOLLSTEINE = 'kalksandsteine_vollsteine';
export const STEINSORTE_ZIEGEL_VOLLSTEIN = 'ziegel_vollstein';
export const STEINSORTE_LOCHSTEINE = 'lochsteine';

export const WANDSTAERKE__09_5 = '9_5';
export const WANDSTAERKE__10_0 = '10_0';
export const WANDSTAERKE__10_5 = '10_5';
export const WANDSTAERKE__11_5 = '11_5';
export const WANDSTAERKE__12_5 = '12_5';
export const WANDSTAERKE__15_0 = '15_0';
export const WANDSTAERKE__17_5 = '17_5';
export const WANDSTAERKE__20_0 = '20_0';
export const WANDSTAERKE__24_0 = '24_0';
export const WANDSTAERKE__25_0 = '25_0';
export const WANDSTAERKE__30_0 = '30_0';
export const WANDSTAERKE__36_5 = '36_5';

export const GEBERIT_SILENT_PRO = 'geberit_silent_pro';
export const GEBERIT_SILENT_DB20 = 'geberit_silent_db20';
export const GEBERIT_SILENT_PP = 'geberit_silent_pp';
export const GEBERIT_VOLEX = 'geberit_volex';
export const GEBERIT_MAPRESS = 'geberit_mapress';
export const GEBERIT_MEPLA = 'geberit_mepla';
export const FAKE_ITEM = '';

export const INSTALLATIONSSYSTEM_CHOICES = {
    [INSTALLATIONSSYSTEM_GEBERIT_DUOFIX]: {
        label: translation.Header_Duofix,
        group: GROUP__RED,
    },
    [INSTALLATIONSSYSTEM_GEBERIT_GIS]: {
        label: translation.Header_GIS,
        group: GROUP__YELLOW,
    },
    [INSTALLATIONSSYSTEM_GEBERIT_KOMBIFIX]: {
        label: translation.Header_Kombix,
        group: GROUP__GREEN,
    },
};
export const WANDAUFBAU_CHOICES = {
    [WANDAUFBAU__VORWANDINSTALLATION_VOR_MASSIVER_TRENNWAND]: {
        label: 'WANDAUFBAU__VORWANDINSTALLATION_VOR_MASSIVER_TRENNWAND',
        belongsToGroups: [GROUP__RED, GROUP__YELLOW],
        group: GROUP__BLUE,
    },
    [WANDAUFBAU__VORWANDINSTALLATION_VOR_TROCKENBAUWAND]: {
        label: 'WANDAUFBAU__VORWANDINSTALLATION_VOR_TROCKENBAUWAND',
        belongsToGroups: [GROUP__RED, GROUP__YELLOW],
        group: null,
    },
    [WANDAUFBAU__RAUMABSCHLIESSENDE_TROCKENBAUWAND]: {
        label: 'WANDAUFBAU__RAUMABSCHLIESSENDE_TROCKENBAUWAND',
        belongsToGroups: [GROUP__RED, GROUP__YELLOW],
        group: null,
    },
    [WANDAUFBAU__VORWANDINSTALLATION_GEBERIT_DUOFIX]: {
        label: 'WANDAUFBAU__VORWANDINSTALLATION_GEBERIT_DUOFIX',
        belongsToGroups: [GROUP__RED, GROUP__YELLOW],
        group: null,
    },
    [WANDAUFBAU__MONTAGEELEMENT_RAUMABSCHLIESSENDE_TROCKENBAUWAND]: {
        label: 'WANDAUFBAU__MONTAGEELEMENT_RAUMABSCHLIESSENDE_TROCKENBAUWAND',
        belongsToGroups: [GROUP__RED],
        group: null,
    },
    [WANDAUFBAU__MONTAGEELEMENT_GEMAUERTER_VORWAND]: {
        label: 'WANDAUFBAU__MONTAGEELEMENT_GEMAUERTER_VORWAND',
        belongsToGroups: [GROUP__GREEN],
        group: GROUP__BLUE,
    },
};

export const STEINSORTE_CHOICES = {
    [STEINSORTE_BASISWAND_GEBERIT]: {
        label: 'STEINSORTE_BASISWAND_GEBERIT',
        belongsToGroups: [GROUP__BLUE],
        group: GROUP__TRIANGLE_YELLOW,
        wandstaerken: null,
        name: translation.STEINSORTE_BASISWAND_GEBERIT,
    },
    [STEINSORTE_BIMS_VOLLSTEINE]: {
        label: 'STEINSORTE_BIMS_VOLLSTEINE',
        belongsToGroups: [GROUP__BLUE],
        group: GROUP__TRIANGLE_YELLOW,
        wandstaerken: [WANDSTAERKE__09_5, WANDSTAERKE__11_5, WANDSTAERKE__17_5, WANDSTAERKE__24_0, WANDSTAERKE__30_0],
        name: translation.STEINSORTE_BIMS_VOLLSTEINE,
    },
    [STEINSORTE_BIMS_HOHLBLOCKSTEINE]: {
        label: 'STEINSORTE_BIMS_HOHLBLOCKSTEINE',
        belongsToGroups: [GROUP__BLUE],
        group: GROUP__TRIANGLE_YELLOW,
        wandstaerken: [WANDSTAERKE__17_5, WANDSTAERKE__24_0, WANDSTAERKE__30_0, WANDSTAERKE__36_5],
        name: translation.STEINSORTE_BIMS_HOHLBLOCKSTEINE,
    },
    [STEINSORTE_HOCHLOCHZIEGEL_KLEIN]: {
        label: 'STEINSORTE_HOCHLOCHZIEGEL_KLEIN',
        belongsToGroups: [GROUP__BLUE],
        group: GROUP__TRIANGLE_YELLOW,
        wandstaerken: [WANDSTAERKE__11_5, WANDSTAERKE__17_5, WANDSTAERKE__24_0, WANDSTAERKE__30_0],
        name: translation.STEINSORTE_HOCHLOCHZIEGEL_KLEIN,
    },
    [STEINSORTE_LEICHTZIEGEL_GROSS]: {
        label: 'STEINSORTE_LEICHTZIEGEL_GROSS',
        belongsToGroups: [GROUP__BLUE],
        group: GROUP__TRIANGLE_YELLOW,
        wandstaerken: [WANDSTAERKE__11_5, WANDSTAERKE__17_5, WANDSTAERKE__24_0, WANDSTAERKE__30_0],
        name: translation.STEINSORTE_LEICHTZIEGEL_GROSS,
    },
    [STEINSORTE_PORENZIEGEL]: {
        label: translation.STEINSORTE_PORENZIEGEL,
        belongsToGroups: [GROUP__BLUE],
        group: GROUP__TRIANGLE_YELLOW,
        wandstaerken: [WANDSTAERKE__11_5, WANDSTAERKE__17_5, WANDSTAERKE__24_0, WANDSTAERKE__36_5],
        name: translation.STEINSORTE_PORENZIEGEL,
    },
    [STEINSORTE_GASBETONSTEINE]: {
        label: 'STEINSORTE_GASBETONSTEINE',
        belongsToGroups: [GROUP__BLUE],
        group: GROUP__TRIANGLE_YELLOW,
        wandstaerken: [WANDSTAERKE__10_0, WANDSTAERKE__12_5, WANDSTAERKE__15_0, WANDSTAERKE__20_0, WANDSTAERKE__25_0, WANDSTAERKE__30_0, WANDSTAERKE__36_5],
        name: translation.STEINSORTE_GASBETONSTEINE,
    },
    [STEINSORTE_KALKSANDSTEINE_VOLLSTEINE]: {
        label: 'STEINSORTE_KALKSANDSTEINE_VOLLSTEINE',
        belongsToGroups: [GROUP__BLUE],
        group: GROUP__TRIANGLE_YELLOW,
        wandstaerken: [WANDSTAERKE__11_5, WANDSTAERKE__17_5, WANDSTAERKE__24_0, WANDSTAERKE__30_0],
        name: translation.STEINSORTE_KALKSANDSTEINE_VOLLSTEINE,
    },
    [STEINSORTE_ZIEGEL_VOLLSTEIN]: {
        label: 'STEINSORTE_ZIEGEL_VOLLSTEIN',
        belongsToGroups: [GROUP__BLUE],
        group: GROUP__TRIANGLE_YELLOW,
        wandstaerken: [WANDSTAERKE__11_5],
        name: translation.STEINSORTE_ZIEGEL_VOLLSTEIN,
    },
    [STEINSORTE_LOCHSTEINE]: {
        label: 'STEINSORTE_LOCHSTEINE',
        belongsToGroups: [GROUP__BLUE],
        group: GROUP__TRIANGLE_YELLOW,
        wandstaerken: [WANDSTAERKE__11_5, WANDSTAERKE__17_5, WANDSTAERKE__24_0, WANDSTAERKE__30_0, WANDSTAERKE__36_5],
        name: translation.STEINSORTE_LOCHSTEINE,
    }
};

export const WANDSTAERKE_CHOICES = {
    [WANDSTAERKE__09_5]: { label: '9.5', belongsToGroups: [GROUP__BLUE], group: null },
    [WANDSTAERKE__10_0]: { label: '10.0', belongsToGroups: [GROUP__BLUE], group: null },
    [WANDSTAERKE__10_5]: { label: '10.5', belongsToGroups: [GROUP__BLUE], group: null },
    [WANDSTAERKE__11_5]: { label: '11.5', belongsToGroups: [GROUP__BLUE], group: null },
    [WANDSTAERKE__12_5]: { label: '12.5', belongsToGroups: [GROUP__BLUE], group: null },
    [WANDSTAERKE__15_0]: { label: '15.0', belongsToGroups: [GROUP__BLUE], group: null },
    [WANDSTAERKE__17_5]: { label: '17.5', belongsToGroups: [GROUP__BLUE], group: null },
    [WANDSTAERKE__20_0]: { label: '20.0', belongsToGroups: [GROUP__BLUE], group: null },
    [WANDSTAERKE__24_0]: { label: '24.0', belongsToGroups: [GROUP__BLUE], group: null },
    [WANDSTAERKE__25_0]: { label: '25.0', belongsToGroups: [GROUP__BLUE], group: null },
    [WANDSTAERKE__30_0]: { label: '30.0', belongsToGroups: [GROUP__BLUE], group: null },
    [WANDSTAERKE__36_5]: { label: '36.5', belongsToGroups: [GROUP__BLUE], group: null },
};

export const KORREKTURWERTE = {
    [STEINSORTE_BIMS_VOLLSTEINE]: {
        [WANDSTAERKE__09_5]: [4.5, 3.0, 2.5, 2.5, 104.5, 134.5],
        [WANDSTAERKE__11_5]: [3.0, 2.0, 1.5, 0.0, 126.5, 156.5],
        [WANDSTAERKE__17_5]: [-0.5, -0.5, -1.5, -1.0, 192.0, 222.0],
        [WANDSTAERKE__24_0]: [-3.0, -2.0, -4.0, -3.0, 264.0, 294.0],
        [WANDSTAERKE__30_0]: [-4.0, -3.0, -4.0, -3.0, 330.0, 360.0],
    },
    [STEINSORTE_BIMS_HOHLBLOCKSTEINE]: {
        [WANDSTAERKE__17_5]: [-0.5, -0.5, -1.5, -1.0, 192.5, 222.5],
        [WANDSTAERKE__24_0]: [-3.0, -2.0, -3.0, -4.0, 264.0, 294.0],
        [WANDSTAERKE__30_0]: [-4.0, -3.0, -4.0, -3.0, 330.0, 360.0],
        [WANDSTAERKE__36_5]: [-4.0, -3.0, -4.0, -3.0, 401.5, 431.5],
    },
    [STEINSORTE_HOCHLOCHZIEGEL_KLEIN]: {
        [WANDSTAERKE__11_5]: [1.0, 1.0, -0.5, -0.5, 161.0, 191.0],
        [WANDSTAERKE__17_5]: [-2.0, 1.0, -3.5, -2.5, 245.0, 275.0],
        [WANDSTAERKE__24_0]: [-4.0, -3.0, -4.0, -3.0, 336.0, 366.0],
        [WANDSTAERKE__30_0]: [-4.0, -3.0, -4.0, -3.0, 420.0, 450.0],
    },
    [STEINSORTE_LEICHTZIEGEL_GROSS]: {
        [WANDSTAERKE__11_5]: [2.0, 1.5, 0.5, 0.5, 138.0, 168.0],
        [WANDSTAERKE__17_5]: [-1.5, -1.0, -2.5, -2.0, 210.0, 240.0],
        [WANDSTAERKE__24_0]: [-4.0, -3.0, -4.0, -3.0, 288.0, 318.0],
        [WANDSTAERKE__30_0]: [-4.0, -3.0, -4.0, -3.0, 360.0, 390.0],
    },
    [STEINSORTE_PORENZIEGEL]: {
        [WANDSTAERKE__11_5]: [3.5, 2.5, 1.5, 1.0, 115.0, 145.0],
        [WANDSTAERKE__17_5]: [0.0, 0.0, -1.0, -0.5, 175.0, 205.0],
        [WANDSTAERKE__24_0]: [-2.0, 1.0, -3.5, -2.5, 240.0, 270.0],
        [WANDSTAERKE__30_0]: [-4.0, -3.0, 4.0, -3.0, 300.0, 330.0],
        [WANDSTAERKE__36_5]: [-4.0, -3.0, 4.0, -3.0, 365.0, 395.0],
    },
    [STEINSORTE_GASBETONSTEINE]: {
        [WANDSTAERKE__10_0]: [5.0, 3.0, 4.0, 2.5, 80.0, 110.0],
        [WANDSTAERKE__12_5]: [4.5, 3.0, 2.0, 1.5, 100.0, 130.0],
        [WANDSTAERKE__15_0]: [3.0, 2.0, 1.5, 1.0, 120.0, 150.0],
        [WANDSTAERKE__20_0]: [1.0, 0.5, -0.5, -0.5, 160.0, 190.0],
        [WANDSTAERKE__25_0]: [-1.0, -0.5, -2.0, -1.5, 200.0, 230.0],
        [WANDSTAERKE__30_0]: [-2.5, -2.0, -3.5, -2.5, 240.0, 270.0],
        [WANDSTAERKE__36_5]: [-4.0, -3.0, -4.0, -3.0, 292.0, 322.0],
    },
    [STEINSORTE_KALKSANDSTEINE_VOLLSTEINE]: {
        [WANDSTAERKE__11_5]: [-1.0, -0.5, -2.0, -1.5, 201.0, 231.0],
        [WANDSTAERKE__17_5]: [-4.0, -3.0, -4.0, -3.0, 306.0, 336.0],
        [WANDSTAERKE__24_0]: [-4.0, -3.0, -4.0, -3.0, 420.0, 450.0],
        [WANDSTAERKE__30_0]: [-4.0, -3.0, -4.0, -3.0, 525.0, 555.0],
    },
    [STEINSORTE_ZIEGEL_VOLLSTEIN]: {
        [WANDSTAERKE__11_5]: [-0.5, -1.0, -2.0, -1.5, 207, 237.0],
    },
    [STEINSORTE_LOCHSTEINE]: {
        [WANDSTAERKE__11_5]: [0.5, 0.5, -1.0, -0.5, 172.5, 202.5],
        [WANDSTAERKE__17_5]: [-3.0, -2.0, -4.0, -3.0, 262.5, 292.5],
        [WANDSTAERKE__24_0]: [-4.0, -3.0, -4.0, -3.0, 360.0, 390.0],
        [WANDSTAERKE__30_0]: [-4.0, -3.0, -4.0, -3.0, 450.0, 480.0],
        [WANDSTAERKE__36_5]: [-4.0, -3.0, -4.0, -3.0, 547.5, 577.5],
    
    },
};

export const TRINKWASSER_STEIGSTRANG_CHOICES = {
    [GEBERIT_MAPRESS]: { label: 'Geberit Mapress', image: 'geberit_mapress.jpg' },
    [GEBERIT_MEPLA]: { label: 'Geberit Mepla', image: 'geberit_mepla.jpg' },
    [GEBERIT_VOLEX]: { label: 'Geberit Volex', image: 'geberit_volex.jpg' },
};

export const TRINKWASSER_ANSCHLUSSLEITUNG_CHOICES = {
    [GEBERIT_MAPRESS]: { label: 'Geberit Mapress', image: 'geberit_mapress.jpg' },
    [GEBERIT_MEPLA]: { label: 'Geberit Mepla', image: 'geberit_mepla.jpg' },
    [GEBERIT_VOLEX]: { label: 'Geberit Volex', image: 'geberit_volex.jpg' },
};

export const ABWASSER_FALLLEITUNG_CHOICES = {
    [GEBERIT_SILENT_PRO]: { label: 'Geberit Silent-Pro', image: 'geberit_silent-pro.jpg' },
    [GEBERIT_SILENT_DB20]: { label: 'Geberit Silent-db20', image: 'geberit_silent-db20.jpg' },
    [GEBERIT_SILENT_PP]: { label: 'Geberit Silent-PP', image: 'geberit_silent-pp.jpg' },
};

export const ABWASSER_ANSCHLUSSLEITUNG_CHOICES = {
    [GEBERIT_SILENT_PRO]: { label: 'Geberit Silent-Pro', image: 'geberit_silent-pro.jpg' },
    [GEBERIT_SILENT_DB20]: { label: 'Geberit Silent-db20', image: 'geberit_silent-db20.jpg' },
    [GEBERIT_SILENT_PP]: { label: 'Geberit Silent-PP', image: 'geberit_silent-pp.jpg' },
};
//GIS Vorwandinstallation vor massiver Trennwand
export const XML_SEARCH_GIS_VORWAND_VOR_MASSIVER_TRENNWAND = ["6451220491", "6451239051"];
//GIS Vorwandinstallation vor Trockenbauwand
export const XML_SEARCH_GIS_VORWAND_VOR_TROCKENBAUWAND = ["6451220491", "6451221643"];
//GIS raumhohe Trennwand
export const XML_SEARCH_GIS_RAUMHOHE_TRENNWAND = ["6451245963"];
//GIS Vorwandinstallation vor Duofix Systemwand (EinfachstÃ¤nder)
export const XML_SEARCH_GIS_VORWAND_VOR_DUOFIX_SYSTEMWAND = ["6451220491", "6451240203"];
//Duofix System Vorwandinstallation vor massiver Trennwand
export const XML_SEARCH_DUOFIX_VORWAND_VOR_MASSIVER_TRENNWAND = ["6451219339", "6451239051"];
//Duofix System Vorwandinstallation vor Trockenbauwand
export const XML_SEARCH_DUOFIX_VORWAND_VOR_TROCKENBAUWAND = ["6451219339", "6451221643"];
//Duofix System als raumhohe Trockenbautrennwand
export const XML_SEARCH_DUOFIX_ALS_RAUMHOHE_TROCKENBAUTRENNWAND = ["6451244811"];
//Duofix System Vorwandinstallation vor Duofix Systemwand
export const XML_SEARCH_DUOFIX_VORWAND_VOR_DUOFIX_SYSTEMWAND = ["6451219339", "6451240203"];
//Duofix Element in Trockenbautrennwand
export const XML_SEARCH_DUOFIX_IN_TROCKENBAUTRENNWAND = ["6452776331"];
//Kombifix Element in massiver Vorwand vor massiver Trennwand
export const XML_SEARCH_KOMBIFIX_IN_MASSIVER_VORWAND_VOR_MASSIVER_TRENNWAND = ["6451239051", "6451218187"];

export const XML_BUBBLE_ENTWAESSERUNG_FALLLEITUNG = 0;
export const XML_BUBBLE_ENTWAESSERUNG_ANSCHLUSSLEITUNG = 1;
export const XML_BUBBLE_ANGRENZENDER_RAUM = 2;
export const XML_BUBBLE_DIAGONAL_DARUNTERLIEGENDER_RAUM = 3;
export const XML_BUBBLE_TRINKWASSER_LEITUNG = 4;
export const XML_BUBBLE_DUOFIX_GIS_KOMBIFIX_ELEMENTE = 5;
export const XML_BUBBLE_TRENNWAND = 6;
export const XML_BUBBLE_VORWAND = 7;
export const XML_BUBBLE_SCHALLSCHUTZ_SET = 8;

export const XML_BUBBLE_POSITIONS = {
    [XML_BUBBLE_ENTWAESSERUNG_FALLLEITUNG]: { posX: 60, posY: 5 },
    [XML_BUBBLE_ENTWAESSERUNG_ANSCHLUSSLEITUNG]: { posX: 36, posY: 49 },
    [XML_BUBBLE_ANGRENZENDER_RAUM]: { posX: 20, posY: 27 },
    [XML_BUBBLE_DIAGONAL_DARUNTERLIEGENDER_RAUM]: { posX: 20, posY: 80 },
    [XML_BUBBLE_TRINKWASSER_LEITUNG]: { posX: 68, posY: 4 },
    [XML_BUBBLE_DUOFIX_GIS_KOMBIFIX_ELEMENTE]: { posX: 54, posY: 42 },
    [XML_BUBBLE_TRENNWAND]: { posX: 22, posY: 42 },
    [XML_BUBBLE_VORWAND]: { posX: 39, posY: 33 },
    [XML_BUBBLE_SCHALLSCHUTZ_SET]: { posX: 48, posY: 79 },
};
